<template>
  <div class="fab-cell">
    <div class="fab-cell-text">{{ title }}</div>
    <v-btn @click="$emit('fabOptionClicked')" fab small color="#ffffff">
      <v-icon color="#404040">{{ image }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'fab-options-btn',
  props: {
    title: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.fab-cell {
  display: flex;
  align-items: center;
  margin-right: 55px;
  width: 120px;
  justify-content: space-between;
  background: none;
}

.fab-cell-text {
  font-family: Lato;
  font-size: 14px;
  color: white;
}
</style>
